import ControlViewModel from '@/ViewModels/ControlViewModel';
import PrincipalHistorizationSelectionViewModelT from '@/ViewModels/Controls/PrincipalHistorizationSelectionViewModel';
import PrincipalHistorizationPreviewViewModelT from '@/ViewModels/Controls/PrincipalHistorizationPreviewViewModel';
import PrincipalHistorizationSelectionItemViewModelT from '@/ViewModels/Controls/PrincipalHistorizationSelectionItemViewModel';
import PrincipalHistorizationPreviewItemViewModelT from '@/ViewModels/Controls/PrincipalHistorizationPreviewItemViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import CheckBoxViewModelT from '@/ViewModels/Controls/CheckBoxViewModel';
import ImageViewModelT from '@/ViewModels/Controls/ImageViewModel';
import DateTimeLabelViewModelT from '@/ViewModels/Controls/DateTimeLabelViewModel';
import ComponentManager from '@/Management/ComponentManager';
import GlobalConfiguration from '@/Management/GlobalConfiguration';
import * as Convert from '@/Utility/Convert';
import * as DateHelper from '@/Utility/DateHelper';

declare let moment: moment.MomentStatic;

export default class PrincipalHistorizationOverviewViewModel extends ControlViewModel {
    /**
    * Die Mandantenauswahl
    * @type {PrincipalHistorizationSelectionViewModel}
    */
    public selection: any;
    /**
    * Die historisierten Mandanten
    * @type {PrincipalHistorizationPreviewViewModel}
    */
    public preview: any;
    /**
    * Gibt an, ob die Komponente im Summary-Modus dargestellt werden soll
    */
    public isSummaryMode: boolean;
    /**
    * Das maximale Datum zu dem ein Mandant erzeugt sein muss damit dieser ausgewählt werden kann
    */
    public maxPrincipalCreatedDate: KnockoutObservable<any>;
    /**
    * Gibt an, ob mindestens ein Mandant selektiert ist
    */
    public isAnyPrincipalSelected: KnockoutObservable<boolean>;
    /**
    * Der Wert des Controls
    */
    public value: any;
    public _originalXML: any;
    public _hasChanged: any;
    /**
    * Das aus dem Wert generierte XML
    */
    public xml: any;
    private PrincipalHistorizationSelectionViewModel: any;
    private PrincipalHistorizationPreviewViewModel: any;
    private PrincipalHistorizationSelectionItemViewModel: any;
    private PrincipalHistorizationPreviewItemViewModel: any;
    private LabelViewModel: any;
    private CheckBoxViewModel: any;
    private ImageViewModel: any;
    private DateTimeLabelViewModel: any;
    constructor(params: any) {
        super(params);
        this.PrincipalHistorizationSelectionViewModel = ComponentManager.getViewModel<typeof PrincipalHistorizationSelectionViewModelT>('PrincipalHistorizationSelectionViewModel');
        this.PrincipalHistorizationPreviewViewModel = ComponentManager.getViewModel<typeof PrincipalHistorizationPreviewViewModelT>('PrincipalHistorizationPreviewViewModel');
        this.PrincipalHistorizationSelectionItemViewModel = ComponentManager.getViewModel<typeof PrincipalHistorizationSelectionItemViewModelT>('PrincipalHistorizationSelectionItemViewModel');
        this.PrincipalHistorizationPreviewItemViewModel = ComponentManager.getViewModel<typeof PrincipalHistorizationPreviewItemViewModelT>('PrincipalHistorizationPreviewItemViewModel');
        this.LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
        this.CheckBoxViewModel = ComponentManager.getViewModel<typeof CheckBoxViewModelT>('CheckBoxViewModel');
        this.ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');
        this.DateTimeLabelViewModel = ComponentManager.getViewModel<typeof DateTimeLabelViewModelT>('DateTimeLabelViewModel');
        this.value = this.observableOrDefault(params.value, {});
        this.isSummaryMode = this.paramOrDefault(params.isSummaryMode, false);
        this.maxPrincipalCreatedDate = this.observableOrDefault(params.maxPrincipalCreatedDate, null);
        this.defineSubscription(this.maxPrincipalCreatedDate, (maxPrincipalCreatedDate) => {
            let value = this.value();
            if (value.historizable != null) {
                for (let i = 0; i < value.historizable.length; i++) {
                    let createdAt = moment(value.historizable[i].createdAt);
                    let isEnabled = maxPrincipalCreatedDate.diff(createdAt) >= 0;
                    value.historizable[i].isEnabled(isEnabled);
                    if (isEnabled === false) {
                        value.historizable[i].toBeHistorized(false);
                    }
                }
            }
        });
        this._originalXML = params.xml();
        this._hasChanged = this.observableOrDefault(false);
        this.xml = this.definePureComputed((() => {
            return {
                read: () => {
                    if (this._hasChanged() === false) {
                        return this._originalXML;
                    }
                    let value = this.value();
                    let param = {
                        PrincipalHistorizationOverviewXml: {
                            HistorizablePrincipalSelection: {
                                Principal: []
                            }
                        }
                    };
                    if (value.historizable != null) {
                        for (let i = 0; i < value.historizable.length; i++) {
                            param.PrincipalHistorizationOverviewXml.HistorizablePrincipalSelection.Principal.push({
                                '@Name': value.historizable[i].name,
                                '@ToBeHistorized': value.historizable[i].toBeHistorized()
                            });
                        }
                    }
                    let xml = Convert.ObjectToXMLString(param);
                    return xml;
                },
                write: (xml) => {
                    let value = { historizable: [], historized: [] };
                    let old = this.value();
                    let XMLRoot = Convert.XMLStringToObject(xml) as any;
                    if (XMLRoot != null) {
                        let HistorizablePrincipals = XMLRoot.PrincipalHistorizationOverviewXml.HistorizablePrincipals || XMLRoot.PrincipalHistorizationOverviewXml.HistorizablePrincipalSelection;
                        let HistorizedPrincipals = XMLRoot.PrincipalHistorizationOverviewXml.HistorizedPrincipals || XMLRoot.PrincipalHistorizationOverviewXml.HistorizedPrincipalSelection;
                        if (HistorizablePrincipals != null) {
                            if (_.isArray(HistorizablePrincipals.Principal)) {
                                for (let i = 0; i < HistorizablePrincipals.Principal.length; i++) {
                                    let Principal = HistorizablePrincipals.Principal[i];
                                    this.analysePrincipal(Principal, value);
                                }
                            } else {
                                this.analysePrincipal(HistorizablePrincipals.Principal, value);
                            }
                        }
                        if (HistorizedPrincipals != null && HistorizedPrincipals.Log != null) {
                            if (_.isArray(HistorizedPrincipals.Log.Entry)) {
                                for (let i = 0; i < HistorizedPrincipals.Log.Entry.length; i++) {
                                    let Entry = HistorizedPrincipals.Log.Entry[i];
                                    this.analyseEntry(Entry, value);
                                }
                            } else {
                                this.analyseEntry(HistorizedPrincipals.Log.Entry, value);
                            }
                        }
                        if (JSON.stringify(old) !== JSON.stringify(value)) {
                            this.value(value);
                        }
                    }
                }
            };
        })(), params.xml);
        this.selection = this.paramOrDefault((() => {
            return new this.PrincipalHistorizationSelectionViewModel({
                parentLocator: this.locator,
                locator: 'selection',
                isVisible: this.isSummaryMode === false,
                items: this.defineComputed(() => {
                    let result = [];
                    let value = this.value();
                    if (value.historizable != null) {
                        for (let i = 0; i < value.historizable.length; i++) {
                            let historizable = value.historizable[i];
                            result.push(new this.PrincipalHistorizationSelectionItemViewModel({
                                parentLocator: this.locator,
                                locator: 'selection.' + i,
                                isEnabled: historizable.isEnabled,
                                label: new this.LabelViewModel({
                                    parentLocator: this.locator,
                                    locator: 'selection.' + i + '.label',
                                    caption: historizable.name
                                }),
                                checkbox: new this.CheckBoxViewModel({
                                    parentLocator: this.locator,
                                    locator: 'selection.' + i + '.checkbox',
                                    isChecked: historizable.toBeHistorized
                                })
                            }));
                        }
                    }
                    return result;
                })
            });
        })());
        this.preview = this.paramOrDefault((() => {
            return new this.PrincipalHistorizationPreviewViewModel({
                parentLocator: this.locator,
                locator: 'preview',
                items: this.defineComputed(() => {
                    let result = [];
                    let value = this.value();
                    if (value.historized != null) {
                        for (let i = 0; i < value.historized.length; i++) {
                            let historized = value.historized[i];
                            result.push(new this.PrincipalHistorizationPreviewItemViewModel({
                                parentLocator: this.locator,
                                locator: 'preview.' + i,
                                image: new this.ImageViewModel({
                                    source: GlobalConfiguration.inlineImages.INFO_DARK,
                                    tooltip: new this.LabelViewModel({
                                        parentLocator: this.locator,
                                        locator: 'preview.' + i + '.image',
                                        caption: historized.historizedBy + ': ' + historized.description
                                    }),
                                    alternativeText: new this.LabelViewModel({
                                        ergName: 'INFO'
                                    })
                                }),
                                label: new this.LabelViewModel({
                                    parentLocator: this.locator,
                                    locator: 'preview.' + i + '.label',
                                    caption: historized.principalName
                                }),
                                datetimelabel: new this.DateTimeLabelViewModel({
                                    parentLocator: this.locator,
                                    locator: 'preview.' + i + '.datetime',
                                    value: DateHelper.timeStampToString(historized.historizationTimestamp)
                                })
                            }));
                        }
                    }
                    return result;
                })
            });
        })());
        this.isAnyPrincipalSelected = this.selection.isAnyPrincipalSelected;
        ControlViewModel.checkProperties(this, params);
    }
    private analysePrincipal(Principal: any, value: any): any {
        if (Principal != null) {
            let toBeHistorized = this.observableOrDefault(JSON.parse(Principal['@ToBeHistorized']));
            this.defineSubscription(toBeHistorized, () => {
                this._hasChanged(true);
            });
            value.historizable.push({
                name: Principal['@Name'],
                createdAt: Principal['@CreatedAt'],
                toBeHistorized: toBeHistorized,
                isEnabled: this.observableOrDefault(JSON.parse(Principal['@IsEnabled'] || true))
            });
        }
    }
    private analyseEntry(Entry: any, value: any): any {
        if (Entry != null) {
            value.historized.push({
                principalName: Entry.PrincipalName,
                historizedBy: Entry.HistorizedBy,
                description: Entry.Description,
                historizationTimestamp: JSON.parse(Entry.HistorizationTimestamp)
            });
        }
    }
}

ComponentManager.setViewModel('PrincipalHistorizationOverviewViewModel', PrincipalHistorizationOverviewViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');